var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcChevronUp = function SvgIcChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.83 16.34a.562.562 0 0 1-.397.16.561.561 0 0 1-.396-.16L11.5 9.276l-7.537 7.066a.562.562 0 0 1-.396.159.562.562 0 0 1-.397-.16c-.227-.212-.227-.548 0-.743l7.933-7.438c.227-.212.586-.212.794 0l7.933 7.438a.492.492 0 0 1 0 .744Z",
    fill: "currentColor"
  })));
};
export default SvgIcChevronUp;